export default {
    namespaced: true,
    state: {
        refetchEvents: false,
        selectedContentsIds: [],
        calendarDefaultView: 'dayGridMonth',
    },
    getters: {
        refetchEvents: state => state.refetchEvents,
        selectedContentsIds: state => state.selectedContentsIds,
        calendarDefaultView: state => state.calendarDefaultView,
    },
    mutations: {
        setRefetchEvents(state, payload) {
            state.refetchEvents = payload;
        },
        setSelectedContentsIds(state, payload) {
            state.selectedContentsIds = payload;
        },
        setCalendarDefaultView(state, payload) {
            state.calendarDefaultView = payload;
        },
    },
};
